



































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _ from "lodash";

import {
  ExpenseGroup,
  ExpenseDictionary,
  PossibleExpense,
  ExpenseEligibility,
  ExpenseEligibilityGroup
} from "@/shared/types";

import Widget from "@/shared/components/Widget.vue";
import ExpenseRow from "@/shared/components/expense/ExpenseRow.vue";
import { formatCurrency } from "@/shared/currency";
import { useExpenseStore } from "@/employee/store/expense";

@Component({
  components: {
    Widget,
    ExpenseRow
  }
})
export default class ExpensesList extends Vue {
  expenseStore = useExpenseStore();

  @Prop()
  expenses: PossibleExpense[];

  @Prop()
  listType: string;

  @Prop()
  expenseType: number;

  @Prop()
  total: number;

  @Prop()
  loading: boolean;

  @Prop()
  toggleDisplay: () => void;

  @Prop()
  panelOpen: boolean;

  formatCurrency = formatCurrency;
  ExpenseEligibility = ExpenseEligibility;
  isChecked = false;
  transactionIdDictionary = {};
  selectedExpenseEligibility = ExpenseEligibility.Eligible;
  selectedExpensesCount = 0;
  isUndoButtonDisabled = false;
  isSubmitDisabled = true;

  resetTransactionsDictionary (): void {
    this.isChecked = false;
    this.transactionIdDictionary = {};
    this.isSubmitDisabled = true;
  }

  @Watch("expenses")
  resetSelectAll (): void {
    let allExpensesSelected = true;
    const expenseIds = this.expenses.map(x => x.transactionId);
    _.forEach(this.expenses, x => {
      const existingSelectedExpense = this.transactionIdDictionary[x.transactionId];
      if (existingSelectedExpense === undefined) {
        allExpensesSelected = false;
      }
    });
    this.isChecked = allExpensesSelected;
  }

  get showApproveAll (): boolean {
    return !!(this.expenses && this.expenses.filter(item => item.eligibilityStatus === ExpenseEligibility.None).length);
  }

  get eligibleSelected (): boolean {
    return this.selectedExpenseEligibility === ExpenseEligibility.Eligible;
  }

  get ineligibleSelected (): boolean {
    return this.selectedExpenseEligibility === ExpenseEligibility.Ineligible;
  }

  get undoableTransactions () {
    if (this.expenseType === ExpenseEligibilityGroup.LikelyEligible) {
      return this.expenseStore.likelyUndoableTransactions;
    } else if (this.expenseType === ExpenseEligibilityGroup.PotentialEligible) {
      return this.expenseStore.potentialUndoableTransactions;
    } else {
      return this.expenseStore.unlikelyUndoableTransactions;
    }
  }

  get undoableTransactionCount (): number {
    return this.undoableTransactions.length;
  }

  get shouldUndoBeDisabled (): boolean {
    return this.undoableTransactionCount === 0 || this.isUndoButtonDisabled;
  }

  @Watch("undoableTransactions")
  checkUndoableTransactions (newValue, oldValue) {
    if ((oldValue && oldValue.length) && (!newValue || !newValue.length)) {
      this.resetTransactionsDictionary();
    }
  }

  isSelected (transactionId: string): boolean {
    return _.has(this.transactionIdDictionary, transactionId);
  }

  resetTransactionStatus () {
    this.isUndoButtonDisabled = true;
    const statusToChange = [];
    this.undoableTransactions.forEach(t => {
      statusToChange.push({
        transactionId: t,
        eligibilityStatus: ExpenseEligibility.None
      });
    });
    const expensesToReset = {
      transactionType: this.expenseType,
      expenseStatusList: statusToChange
    };
    this.expenseStore.setEligibility(expensesToReset);
    this.isUndoButtonDisabled = false;
    this.selectedExpenseEligibility = ExpenseEligibility.Eligible;
  }

  toggleSelectAll (isChecked: boolean): void {
    if (isChecked) {
      const expenseIds = _.keyBy(this.expenses.map(x => x.transactionId));

      this.transactionIdDictionary = {
        ...this.transactionIdDictionary,
        ...expenseIds
      };
      this.isSubmitDisabled = false;
    } else {
      this.transactionIdDictionary = {};
      this.isSubmitDisabled = true;
    }
    this.selectedExpensesCount = _.size(this.transactionIdDictionary);
  }

  updateTransactionIdDictionary (id: string): void {
    if (this.transactionIdDictionary[id]) {
      _.unset(this.transactionIdDictionary, id);
    } else {
      this.transactionIdDictionary[id] = id;
    }

    this.selectedExpensesCount = _.size(this.transactionIdDictionary);
    this.isSubmitDisabled = _.isEmpty(this.transactionIdDictionary);
  }

  saveSelections (eligibilityStatus): void {
    if (_.isEmpty(this.transactionIdDictionary)) {
      return;
    }

    const transactionsToUpdate = _.map(this.transactionIdDictionary, transactionId => {
      return {
        transactionId,
        eligibilityStatus
      };
    });

    const response = {
      transactionType: this.expenseType,
      expenseStatusList: transactionsToUpdate
    };

    this.expenseStore.setEligibility(response);
    this.selectedExpenseEligibility = ExpenseEligibility.Eligible;
  }
}
